import { CustomPage } from '~/components/pages'
import { getCustomPageProps } from '~/components/pages/api'

export default CustomPage

export const getServerSideProps = getCustomPageProps
